import React, {useEffect, useState} from 'react'
import moment from 'moment'

const InfoCard = (props) => {
  const {
    SelectedClient,
    dataActions,
    newDemande,
    processedDemande,
    proposedDemand,
    acceptedDemand,
    cloturedPositive,
    oldestDelaiTraitement,
    oldestAssignedDemand,
  } = props
  const [tempsInfoCard, setTempsInfoCard] = useState<string>('--:--')
  const tauxDeConversion = proposedDemand > 0 ? (acceptedDemand / proposedDemand) * 100 : 0

 //ne pas compter les messages "lu" dans le total des actions
  const totalFilter = dataActions.filter(
      (action) => !((action?.type?.code === "MESS CLIENT" || action?.type?.code === 'MESS TELEVENDEUR') && action?.statut?.code === "LU") )

  const formatTemps = (durationValue) => {
    let totalSeconds = Math.floor(durationValue.asSeconds())
    const days = Math.floor(totalSeconds / 86400) // 24 * 60 * 60
    totalSeconds %= 86400
    let hours = Math.floor(totalSeconds / 3600)
    totalSeconds %= 3600
    let minutes = Math.floor(totalSeconds / 60)
    let seconds = totalSeconds % 60

    const hoursStr = String(hours).padStart(2, '0')
    const minutesStr = String(minutes).padStart(2, '0')
    const secondsStr = String(seconds).padStart(2, '0')

    setTempsInfoCard(`${hoursStr}:${minutesStr}`)
  }

  useEffect(() => {
    if (oldestAssignedDemand != null && oldestDelaiTraitement != null) {
      // la date et heure de début
      const dateValue = moment(oldestAssignedDemand)
      // la date et heure maximum à ne pas dépasser
      const datemaxValue = moment(oldestDelaiTraitement)

      // une intervale qui se met à jour tous les secondes
      const interval = setInterval(() => {
        // date et heure maintenant à chaque secondes
        const now = moment()
        const increment = true
        // la durée entre la date et l'heure maintenant et la date de début
        let diff = increment
          ? now.diff(dateValue) // incrémenter à partir de maintenant à dateValue
          : datemaxValue.diff(now) // décrémenter à partir de datemaxValue à maintenant

        // Limiter le timer sur une valeur minimal de 0
        let duration = moment.duration(Math.max(0, diff))

        // Si le timer est en mode décrémentation et inférieur à 0
        if (!increment && duration.asSeconds() <= 0) {
          duration = moment.duration(0)

          formatTemps(duration)
          clearInterval(interval)
          return
        }

        formatTemps(duration)
      }, 1000)
    }
  }, [oldestAssignedDemand, oldestDelaiTraitement])

  return (
    <div className='flex-fill'>
      {!SelectedClient && (
        <div id='kpi' className='d-flex gap-3 h-100'>
          {/*demandes Acceptée + Refusée + Acceptée bloquée */}
          <div className='d-flex align-items-start p-3 card bg-light justify-content-evenly'>
            <div
              className='h-40px border-0'
              style={{
                flex: '1 1 0',
                minWidth: 0,
                fontSize: 'clamp(10px, 0.8vw, 14px)',
                lineHeight: '1.2',
              }}
            >
              Total Demandes traitées
            </div>
            <span
              className='fw-semibold text-muted fs-2'
              style={{
                flex: '0 0 auto',
                whiteSpace: 'nowrap',
                marginLeft: '6px',
              }}
            >
              {processedDemande}
            </span>
            <span className='text-primary'></span>
          </div>

          {/* Nouvelle demande du jour */}
          <div className='d-flex align-items-start p-3 card bg-light-info justify-content-evenly'>
            <div
              className='h-40px border-0 text-primary'
              style={{
                flex: '1 1 0',
                minWidth: 0,
                fontSize: 'clamp(10px, 0.8vw, 14px)',
                lineHeight: '1.2',
              }}
            >
              Nouvelles demandes
            </div>
            <span
              className='fw-semibold text-primary text-muted fs-2'
              style={{
                flex: '0 0 auto',
                whiteSpace: 'nowrap',
                marginLeft: '6px',
              }}
            >
              {newDemande}
            </span>
            <span className='text-primary'></span>
          </div>

          {/* Demande la plus ancienne */}
          <div className='d-flex align-items-start p-3 card bg-light-warning justify-content-evenly'>
            <div
              className='h-40px border-0 text-warning'
              style={{
                flex: '1 1 0',
                minWidth: 0,
                fontSize: 'clamp(10px, 0.8vw, 14px)',
                lineHeight: '1.2',
              }}
            >
              Plus ancienne
            </div>
            <span
              className='fw-semibold text-muted fs-2'
              style={{
                flex: '0 0 auto',
                whiteSpace: 'nowrap',
                marginLeft: '6px',
              }}
            >
              {tempsInfoCard}
            </span>
            <span
              className='text-warning'
              style={{
                flex: '0 0 auto',
                fontSize: 'clamp(9px, 0.7vw, 12px)',
                whiteSpace: 'nowrap',
                marginLeft: '6px',
              }}
            >
              Délai max
            </span>
          </div>

          {/* Demande sur statut proposée */}
          <div className='d-flex align-items-start p-3 card bg-light-warning justify-content-evenly'>
            <div
              className='h-40px border-0 text-warning'
              style={{
                flex: '1 1 0',
                minWidth: 0,
                fontSize: 'clamp(10px, 0.8vw, 14px)',
                lineHeight: '1.2',
              }}
            >
              Proposées
            </div>
            <span
              className='fw-semibold text-muted fs-2'
              style={{
                flex: '0 0 auto',
                whiteSpace: 'nowrap',
                marginLeft: '6px',
              }}
            >
              {proposedDemand}
            </span>
            <span
              className='text-warning'
              style={{
                flex: '0 0 auto',
                fontSize: 'clamp(9px, 0.7vw, 12px)',
                whiteSpace: 'nowrap',
                marginLeft: '6px',
              }}
            >
              En attente réponse
            </span>
          </div>

          {/* Demande sur statut acceptée */}
          <div className='d-flex align-items-start p-3 card bg-light-success justify-content-evenly'>
            <div
              className='h-40px border-0 text-success'
              style={{
                flex: '1 1 0',
                minWidth: 0,
                fontSize: 'clamp(10px, 0.8vw, 14px)',
                lineHeight: '1.2',
              }}
            >
              Acceptées
            </div>
            <span
              className='fw-semibold text-muted fs-2'
              style={{
                flex: '0 0 auto',
                whiteSpace: 'nowrap',
                marginLeft: '6px',
              }}
            >
              {acceptedDemand}
            </span>
            <span
              className='text-success'
              style={{
                flex: '0 0 auto',
                fontSize: 'clamp(9px, 0.7vw, 12px)',
                whiteSpace: 'nowrap',
                marginLeft: '6px',
              }}
            >
              A finaliser
            </span>
          </div>

          {/* Demande clôturée positive */}
          <div className='d-flex align-items-start p-3 card bg-light-success justify-content-evenly'>
            <div
              className='h-40px border-0 text-success'
              style={{
                flex: '1 1 0',
                minWidth: 0,
                fontSize: 'clamp(10px, 0.8vw, 14px)',
                lineHeight: '1.2',
              }}
            >
              Clôturées +
            </div>
            <span
              className='fw-semibold text-muted fs-2'
              style={{
                flex: '0 0 auto',
                whiteSpace: 'nowrap',
                marginLeft: '6px',
              }}
            >
              {cloturedPositive}
            </span>
            <span
              className='text-success'
              style={{
                flex: '0 0 auto',
                fontSize: 'clamp(9px, 0.7vw, 12px)',
                whiteSpace: 'nowrap',
                marginLeft: '6px',
              }}
            >
              Ventes réussies
            </span>
          </div>

          {/* Taux de conversion */}
          <div className='d-flex align-items-start p-3 card bg-light-success justify-content-evenly'>
            <div
              className='h-40px border-0 text-success'
              style={{
                flex: '1 1 0',
                minWidth: 0,
                fontSize: 'clamp(10px, 0.8vw, 14px)',
                lineHeight: '1.2',
              }}
            >
              Taux conversion
            </div>
            <span
              className='fw-semibold text-muted fs-2'
              style={{
                flex: '0 0 auto',
                whiteSpace: 'nowrap',
                marginLeft: '6px',
              }}
            >
              {tauxDeConversion == undefined ? '00' : tauxDeConversion.toFixed(2)} %
            </span>
            <span
              className='text-success'
              style={{
                flex: '0 0 auto',
                fontSize: 'clamp(9px, 0.7vw, 12px)',
                whiteSpace: 'nowrap',
                marginLeft: '6px',
              }}
            >
              Performance
            </span>
          </div>
        </div>
      )}
    </div>
  )
}

export default InfoCard